<template>
  <div :class="['text-box', { readonly }]">
    <slot name="left"></slot>
    <input
      :class="['text', textClass]"
      :type="inputType"
      :value="value"
      @input="handleTextInput($event.target.value)"
      @change="handleTextChange"
      :placeholder="placeholder"
      :readonly="readonly"
      :maxlength="maxlength"
    >
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: 'TextBox',

  props: {
    inputType: {
      type: String,
      default: 'text',
    },
    value: {
      type: String,
    },
    placeholder: {
      type: String,
      default: '入力してください',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: String,
      default: '',
    },
    textClass: {
      type: String,
      default: '',
    },
  },

  model: {
    prop: 'value',
    event: 'change-value',
  },

  methods: {
    handleTextInput(text) {
      this.$emit('change-value', text);
      this.$emit('handleTextInput', text);
    },
    handleTextChange() {
      this.$emit('handleTextChange');
    },
    inputData(val) {
      this.$emit('change-value', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.text-box{
  display: flex;
  width: 100%;
  padding: 10px;
  background-color: $white;
  border: solid 1px #B0AEAE;
  border-radius: 5px;
  &.readonly{
    background-color: $disabledGray;
  }
  .text{
    width: 100%;
    flex: 1 1 100%;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 20px;
    outline: none;
    &::placeholder{
      color: #AAA;
    }
  }
}
.one_code {
  text-align:center;
  font-size: 24px!important;
  -moz-appearance:textfield;
}

input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
@media screen and  (max-width: $tabletWidth) {
  .text-box {
    padding-top: 5px!important;
    .text {
      line-height: 10px;
    }
  }
  .one_code {
    font-size: 16px!important;
  }
}
</style>
